import { defineMessages } from 'react-intl';

export default defineMessages({
  how_to_use_steam_key: {
    id: 'support-question.how_to_use_steam_key',
    defaultMessage: 'How do I use my new Steam keys?',
  },
  how_to_use_uplay_key: {
    id: 'support-question.how_to_use_uplay_key',
    defaultMessage: 'How do I use my new Ubisoft Connect keys?',
  },
  how_to_use_ubisoft_key: {
    id: 'support-question.how_to_use_ubisoft_key',
    defaultMessage: 'How do I use my new Ubisoft Connect keys?',
  },
  how_to_use_rockstar_key: {
    id: 'support-question.how_to_use_rockstar_key',
    defaultMessage: 'How do I use my new Rockstar keys?',
  },
  how_to_use_bethesda_key: {
    id: 'support-question.how_to_use_bethesda_key',
    defaultMessage: 'How do I use my new Bethesda keys?',
  },
  how_to_use_esonline_key: {
    id: 'support-question.how_to_use_esonline_key',
    defaultMessage: 'How do I use my new Elder Scrolls Online keys?',
  },
  how_to_use_epicgames_key: {
    id: 'support-question.how_to_use_epicgames_key',
    defaultMessage: 'How do I use my new Epic Games keys?',
  },
  how_to_use_origin_key: {
    id: 'support-question.how_to_use_origin_key',
    defaultMessage: 'How do I use my new Origin keys?',
  },
  how_to_use_oculus_key: {
    id: 'support-question.how_to_use_oculus_key',
    defaultMessage: 'How do I use my new Meta Quest keys?',
  },
  how_to_use_gog_key: {
    id: 'support-question.how_to_use_gog_key',
    defaultMessage: 'How do I use my new GOG keys?',
  },
  how_to_use_magix_key: {
    id: 'support-question.how_to_use_magix_key',
    defaultMessage: 'How do I use my new Magix keys?',
  },
  how_to_use_zenva_key: {
    id: 'support-question.how_to_use_zenva_key',
    defaultMessage: 'How do I use my new Zenva keys?',
  },
  how_to_use_utalk_key: {
    id: 'support-question.how_to_use_utalk_key',
    defaultMessage: 'How do I use my new uTalk keys?',
  },
  how_to_use_eaplay_key: {
    id: 'support-question.how_to_use_eaplay_key',
    defaultMessage: 'How do I use my new EA keys?',
  },
  how_to_use_all_other_key: {
    id: 'support-question.how_to_use_all_other_key',
    defaultMessage: 'How do I use all other keys?',
  },
  key_time_limit: {
    id: 'support-question.key_time_limit',
    defaultMessage: 'Do I have a time limit for redeeming a key?',
  },
  why_manual_auth: {
    id: 'support-question.why_manual_auth',
    defaultMessage: 'Why is my order status \'Manual Authorisation\'?',
  },
  activate_gift_card: {
    id: 'support-question.activate_gift_card',
    defaultMessage: 'How do I use my new gift card?',
  },
  can_i_refund: {
    id: 'support-question.can_i_refund',
    defaultMessage: 'Can I get a refund/cancel my order?',
  },
});
